/**
 * Sub1 Template
 * @category testApp
 */
class SoulshieldinfoTempl{
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     * @param  {String} _serverType=''
     */
    static getTempl(_d={}, _serverType='') {
        const soulshieldDefaultData = ['보패/감1','보패/간2','보패/진3','보패/손4','보패/리5','보패/곤6','보패/태7','보패/건8'];
        const soulshieldPosObject = { 8:1, 9:2, 10:3, 11:4, 12:5, 13:6, 14:7, 15:8 };

        let soulshieldList = $('<ul class="character-info-list"></ul>');
        for(let i=0; i<soulshieldDefaultData.length; i++){
            soulshieldList.append(SoulshieldinfoTempl.getSoulshieldBasicListTempl(soulshieldDefaultData,i));
        }

        for(let i=0; i<_d.length; i++){
            if($.inArray(_d[i].pos + '', Object.keys(soulshieldPosObject)) !== -1){
                let posValue = soulshieldPosObject[_d[i].pos];
                soulshieldList[0].children[posValue -1].querySelectorAll('.info-thumb>img')[0].src = _d[i].item.icon;
                soulshieldList[0].children[posValue -1].querySelectorAll('.info-text')[0].innerHTML = _d[i].item.name;
                soulshieldList[0].children[posValue -1].querySelectorAll('.info-text-wrap')[0].className += ' item-color-'+ _d[i].item.grade;
            }
        }
        return soulshieldList[0];
    }

    static getSoulshieldBasicListTempl(_defaultNameArray,_index){
        return `
        <li>
            <span class="info-thumb bg-soulshield-${_index + 1}"><img alt=""></span>
            <div class="info-text-wrap">
                <span class="info-text">${_defaultNameArray[_index]}</span>
                <span class="icon-soulshield shield-num-${_index+1}"><em>${_index+1}</em></span>
            </div>
        </li>
        `;
    }
} // end of class

export default SoulshieldinfoTempl;
